module.exports = __webpack_public_path__ + "static/img/far1_active.ff24e9e1.png";